export default function ContributionComponentDirective() {
  return {
    template: require('./contribution-component.html'),
    scope: {
      assessmentFactorId: '=',
      contributionComponent: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'ContributionComponentController',
    controllerAs: 'contributionComponentVM',
    bindToController: true,
    replace: true
  };
}
